import { NotTranslated } from '@execonline-inc/translations';
import { assertNever } from '@kofno/piper';
import { fromEmpty } from 'maybeasy';
import { observer } from 'mobx-react';
import * as React from 'react';
import { AttributeResource } from '../../Types';
import ShowExcessCompetencyStore from './Store';
import CompetencyLabel from '../CompetencyLabel';

export interface Props {
  competencies: ReadonlyArray<AttributeResource>;
}

class ExcessCompetencies extends React.Component<Props> {
  showExcessCompetencyStore: ShowExcessCompetencyStore = new ShowExcessCompetencyStore();

  render() {
    switch (this.showExcessCompetencyStore.state.kind) {
      case 'open':
        return this.props.competencies.map((competency) => (
          <CompetencyLabel competency={competency} />
        ));
      case 'closed':
        return fromEmpty(this.props.competencies)
          .map((competencies) => (
            <div
              onClick={this.showExcessCompetencyStore.open}
              className="text-gray-900 border border-gray-900 break-keep inline-block rounded-md
                         py-1 px-2 text-xs font-medium tracking-tight cursor-pointer"
            >
              <NotTranslated text={`+${competencies.length}`} />
            </div>
          ))
          .getOrElse(() => <></>);
      default:
        assertNever(this.showExcessCompetencyStore.state);
    }
  }
}

export default observer(ExcessCompetencies);
